// Client-side helpers for auth UX. No security logic here — the backend remains
// the source of truth for password rules and validation.

export const PUBLIC_EMAIL_DOMAINS = [
  "gmail.com", "googlemail.com", "yahoo.com", "yahoo.in", "yahoo.co.in",
  "outlook.com", "hotmail.com", "live.com", "msn.com", "aol.com",
  "icloud.com", "me.com", "proton.me", "protonmail.com", "gmx.com",
  "mail.com", "yandex.com", "zoho.com", "rediffmail.com",
];

export function isPersonalEmail(email) {
  const m = String(email || "").toLowerCase().trim().match(/@([^@\s]+)$/);
  return m ? PUBLIC_EMAIL_DOMAINS.includes(m[1]) : false;
}

// Returns { valid, checks:{len,letter,number}, level:0-4, label, color }
export function scorePassword(pw) {
  pw = pw || "";
  const checks = { len: pw.length >= 8, letter: /[a-zA-Z]/.test(pw), number: /\d/.test(pw) };
  const valid = checks.len && checks.letter && checks.number;
  let pts = 0;
  if (pw.length >= 8) pts++;
  if (pw.length >= 12) pts++;
  if (/[a-z]/.test(pw) && /[A-Z]/.test(pw)) pts++;
  if (/\d/.test(pw)) pts++;
  if (/[^A-Za-z0-9]/.test(pw)) pts++;

  let level = 0, label = "", color = "#e2e8f0";
  if (!pw) return { valid, checks, level, label, color };
  if (!valid) { level = 1; label = "Weak"; color = "#dc2626"; }
  else if (pts <= 2) { level = 2; label = "Medium"; color = "#d97706"; }
  else if (pts === 3) { level = 3; label = "Strong"; color = "#16a34a"; }
  else { level = 4; label = "Excellent"; color = "#15803d"; }
  return { valid, checks, level, label, color };
}
